import { AppMonitoringService } from './logging.service';
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HomepageService } from "./homepage.service";
import { CookieService } from "ngx-cookie-service";
import { AuthService } from "./auth.service";
import { environment } from "src/environments/environment";
import { catchError, map } from "rxjs/operators";
import { EMPTY, Observable, throwError } from "rxjs";
import { TenantService } from "./tenant.service";

@Injectable({
  providedIn: "root",
})
export class WalletAPIService {
  tenant: string = "";
  confiGurationSetting: string = "*";
  locationId: any = "*";

  constructor(
    private http: HttpClient,
    private homepageService: HomepageService,
    private cookieService: CookieService,
    private authService: AuthService,
    private appMonitoringService: AppMonitoringService,
    private tenantService: TenantService
  ) {
    this.tenant = this.tenantService.tenant;
    this.confiGurationSetting = this.tenantService.configurationSetting;

    this.locationId = this.homepageService.getLocationId();
  }
  private readonly apiUrl = environment.apiUrl;
  getMobileOS(): string {
    const userAgent = navigator.userAgent;
    this.appMonitoringService.logEvent("Device OS -" + this.tenant, { userAgent: userAgent });
    if (/android/i.test(userAgent)) {
      return "Android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent) || 
      (userAgent.includes('Macintosh') && 'ontouchend' in document)) {
      return "iOS";
    }
    if (/Windows Phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    return "Unknown";
  }

  getWalletLink(body:any): Observable<any> {
    this.locationId = this.homepageService.getLocationId();
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
      //,'Authorization': auth
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.locationId,
      tenant: this.tenant,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(
        this.apiUrl + 'account/googleWallet/generateAddLink',

        { headers: headers, observe: "response" }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if (response.headers.get("Session-Id")) {
            this.authService.setSessionIdHeader(
              response.headers.get("Session-Id")
            );
          }
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getAppleWalletLink(): Observable<any> {
    this.locationId = this.homepageService.getLocationId();
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
      //,'Authorization': auth
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.locationId,
      tenant: this.tenant,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(
        this.apiUrl + 'account/appleWallet/generatePass',

        { headers: headers, observe: "response", responseType: "arraybuffer" }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if (response.headers.get("Session-Id")) {
            this.authService.setSessionIdHeader(
              response.headers.get("Session-Id")
            );
          }
          return {data: response.body, isNewPass: response.headers.get("isnewpass")};
        }),
        catchError((error) => this.handleError(error))
      );
  }

  public handleError(error: any) {
    if (error.status == 401) {
      this.authService.logoutSubject.next(true);
      return EMPTY;
    } else {
      return throwError(error);
    }
  }
}
